import React, { Suspense, lazy } from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';

/**
 * Pequeñas Puntadas sales page.
 * HERO → RESUMEN → MODELO POR DENTRO → BENEFICIOS → PÁGINAS INTERIORES →
 * VOLÚMENES → BONOS → OFERTA → PREGUNTAS → CIERRE → FOOTER (+ barra móvil).
 * Everything below the hero loads in separate chunks; each block reserves height.
 */
const named = <K extends string,>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) => lazy(() => loader().then(m => ({
  default: m[key]
})));
const SummaryStrip = named(() => import('./components/sections/SummaryStrip'), 'SummaryStrip');
const ModelPreviewSection = named(() => import('./components/sections/ModelPreviewSection'), 'ModelPreviewSection');
const BenefitsSection = named(() => import('./components/sections/BenefitsSection'), 'BenefitsSection');
const InteriorPagesSection = named(() => import('./components/sections/InteriorPagesSection'), 'InteriorPagesSection');
const CollectionSection = named(() => import('./components/sections/CollectionSection'), 'CollectionSection');
const BonusSection = named(() => import('./components/sections/BonusSection'), 'BonusSection');
const OfferSection = named(() => import('./components/sections/OfferSection'), 'OfferSection');
const FaqSection = named(() => import('./components/sections/FaqSection'), 'FaqSection');
const FinalCta = named(() => import('./components/sections/FinalCta'), 'FinalCta');
const Footer = named(() => import('./components/Footer'), 'Footer');
const StickyBuyBar = named(() => import('./components/StickyBuyBar'), 'StickyBuyBar');
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
  id?: string;
}

/** The fallback carries the section id so anchors resolve before the chunk loads. */
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory',
  id
}: DeferredProps) {
  return <Suspense fallback={<div id={id} className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="stc8y6r794oy" />} data-id="element-0" data-mp="stue5svuat90">
      {children}
    </Suspense>;
}
export function App() {
  return <div className="app-root bg-ivory text-graphite" data-id="element-2" data-mp="3ud1f186rfma3">
      <NavBar data-id="element-3" data-mp="3ucjcxuxf2du9" />
      <main data-id="element-4" data-mp="3uevuw836co7b">
        <Hero data-id="element-5" data-mp="d4nvzht0nm2x" />
        <Deferred minHeight="120px" background="bg-blush" data-id="element-6" data-mp="d57g95652mk4">
          <SummaryStrip data-id="element-7" data-mp="d2l936n5u92f" />
        </Deferred>
        <Deferred minHeight="1100px" background="bg-ivory-deep" id="modelo" data-id="element-8" data-mp="851n1kk80rzx">
          <ModelPreviewSection data-id="element-9" data-mp="3glea6jyr55fp" />
        </Deferred>
        <Deferred minHeight="620px" data-id="element-10" data-mp="3gm61hilbgh06">
          <BenefitsSection data-id="element-11" data-mp="3gj1qo2dcin0j" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-paper" id="paginas" data-id="element-12" data-mp="3bncodr9xys0j">
          <InteriorPagesSection data-id="element-13" data-mp="3qaxuzv60z9d7" />
        </Deferred>
        <Deferred minHeight="1000px" id="volumenes" data-id="element-14" data-mp="3qciln9p7y85s">
          <CollectionSection data-id="element-15" data-mp="3ljxuyh1m0b6h" />
        </Deferred>
        <Deferred minHeight="800px" background="bg-blush" id="bonos" data-id="element-16" data-mp="3lj6bg4lae3wk">
          <BonusSection data-id="element-17" data-mp="2xtv8qhkdlzfs" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-ivory-deep" id="oferta" data-id="element-18" data-mp="2xsk46fj3wnnm">
          <OfferSection data-id="element-19" data-mp="2svjwy1aiteux" />
        </Deferred>
        <Deferred minHeight="700px" id="preguntas" data-id="element-20" data-mp="18e19djimhmji">
          <FaqSection data-id="element-21" data-mp="18cgf7v0805m6" />
        </Deferred>
        <Deferred minHeight="420px" background="bg-coral-deep" data-id="element-22" data-mp="1d47xli983518">
          <FinalCta data-id="element-23" data-mp="1d6knqip4wlpd" />
        </Deferred>
      </main>
      <Deferred minHeight="240px" background="bg-graphite-deep" data-id="element-24" data-mp="ygd2xwbnmqli">
        <Footer data-id="element-25" data-mp="13eoce5y1ez37" />
      </Deferred>

      <Suspense fallback={null} data-id="element-26" data-mp="13dwufxxd4zve">
        <StickyBuyBar data-id="element-27" data-mp="13ey4bz2n7gbj" />
      </Suspense>
    </div>;
}